/* AUMI — <featured-product>: galeria com miniaturas, troca de variante e quantidade */
if (!customElements.get('featured-product')) {
  const money = (cents) => {
    if (window.AUMI && typeof window.AUMI.formatMoney === 'function') return window.AUMI.formatMoney(cents);
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
  };

  class FeaturedProduct extends HTMLElement {
    connectedCallback() {
      this.gallery = this.querySelector('[data-gallery]');
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.form = this.querySelector('[data-fp-form]');
      this.initGallery();
      this.initQuantity();
      this.initVariants();
    }

    initGallery() {
      if (!this.gallery || !this.thumbs.length) return;
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.showSlide(Number(thumb.dataset.thumb)));
      });
      let ticking = false;
      this.gallery.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const index = Math.round(this.gallery.scrollLeft / this.gallery.clientWidth);
          this.setCurrentThumb(index);
          ticking = false;
        });
      }, { passive: true });
    }

    showSlide(index) {
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.gallery.scrollTo({ left: this.gallery.clientWidth * index, behavior: smooth ? 'smooth' : 'auto' });
      this.setCurrentThumb(index);
    }

    setCurrentThumb(index) {
      this.thumbs.forEach((thumb, i) => {
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }

    initQuantity() {
      const input = this.querySelector('input[name="quantity"][type="number"]');
      if (!input) return;
      this.querySelectorAll('[data-qty]').forEach((button) => {
        button.addEventListener('click', () => {
          const next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.qty));
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }

    initVariants() {
      const json = this.querySelector('[data-variants]');
      if (!json || !this.form) return;
      try {
        this.variants = JSON.parse(json.textContent);
      } catch (error) {
        return;
      }
      this.variantInput = this.form.querySelector('[data-variant-input]');
      this.addButton = this.form.querySelector('[data-add-button]');
      this.addLabel = this.form.querySelector('[data-add-label]');
      this.defaultLabel = this.addLabel ? this.addLabel.textContent.trim() : '';
      if (this.addButton && this.addButton.disabled) this.defaultLabel = 'Adicionar à sacola';
      this.form.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-index]')) this.onOptionChange();
      });
    }

    onOptionChange() {
      const selected = [];
      this.form.querySelectorAll('[data-option-index]:checked').forEach((input) => {
        selected[Number(input.dataset.optionIndex)] = input.value;
        const label = this.form.querySelector(`[data-option-value="${input.dataset.optionIndex}"]`);
        if (label) label.textContent = input.value;
      });
      const variant = this.variants.find((v) => v.options.every((value, i) => value === selected[i]));

      if (!variant) {
        if (this.addButton) this.addButton.disabled = true;
        if (this.addLabel) this.addLabel.textContent = 'Indisponível';
        return;
      }

      this.variantInput.value = variant.id;
      if (this.addButton) this.addButton.disabled = !variant.available;
      if (this.addLabel) this.addLabel.textContent = variant.available ? this.defaultLabel : 'Esgotado';
      this.updatePrice(variant);

      if (variant.featured_media && this.gallery) {
        const index = Number(variant.featured_media.position) - 1;
        if (index > -1 && index < this.gallery.children.length) this.showSlide(index);
      }
    }

    updatePrice(variant) {
      const wrapper = this.querySelector('[data-price-wrapper]');
      if (!wrapper) return;
      const settings = (window.AUMI && window.AUMI.settings) || {};
      const current = wrapper.querySelector('[data-current-price]');
      if (current) current.textContent = money(variant.price);

      const compare = wrapper.querySelector('[data-compare-price]');
      if (compare) {
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = money(variant.compare_at_price || 0);
      }

      const pix = wrapper.querySelector('[data-pix-price] strong');
      if (pix && settings.pixDiscount) {
        pix.textContent = money(Math.round((variant.price * (100 - settings.pixDiscount)) / 100));
      }

      const installments = wrapper.querySelector('[data-installments]');
      if (installments && settings.installmentsMax) {
        const minCents = settings.installmentMin || 3000;
        const n = Math.max(1, Math.min(settings.installmentsMax, Math.floor(variant.price / minCents)));
        installments.hidden = n < 2;
        installments.textContent = `ou ${n}x de ${money(Math.floor(variant.price / n))} sem juros`;
      }
      wrapper.classList.toggle('price--sold-out', !variant.available);
    }
  }
  customElements.define('featured-product', FeaturedProduct);
}
